import React, { FC } from 'react';
import { GrClose } from 'react-icons/gr';

type Props = {
  setShowWhyConnect: React.Dispatch<React.SetStateAction<boolean | undefined>>;
};

const WhyConnect: FC<Props> = ({ setShowWhyConnect }) => {
  //Handle opening modal exit click
  const handleExit = () => {
    setShowWhyConnect(undefined);
  };

  return (
    <div
      id="popup-modal"
      className={
        'flex flex-col items-stretch justify-center fixed z-50 w-11/12 lg:w-1/3 rounded-lg bg-light-grey shadow-lg max-h-[80vh] h-max lg:top-1/4 lg:left-1/4'
      }
    >
      <button
        type="button"
        className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white outline-confirmed-primary"
        data-modal-toggle="popup-modal"
        onClick={handleExit}
      >
        <span className="sr-only">Close modal</span>
        <GrClose />
      </button>
      <div className="pt-8 pb-2 flex flex-col">
        <span className="flex align-middle justify-evenly">
          <img
            src="/VerticalBarsShowYourBusyTime.png"
            className="rounded-xl w-11/12"
          />
        </span>
      </div>
    </div>
  );
};

export default WhyConnect;
